export default "__VITE_ASSET__DBAlKTr9__"